import React, { useContext } from 'react';
import propTypes from 'prop-types';
import { QuantityContext } from './QuantityProvider';
import { tireInfo } from './helpers';
import { clamp } from '../../utilities/clamp';

const QuantitySelector = ({ sku, isSplitFitment, isFrontTire }) => {
  const { quantities, updateQuantities } = useContext(QuantityContext);
  const quantity = !isSplitFitment || isFrontTire ? quantities.qtyFront : quantities.qtyRear;
  const { minQuantity, maxQuantity, label } = tireInfo({ isSplitFitment, isFrontTire });

  let qty = quantity;
  if (qty !== '') {
    qty = clamp(qty, { min: minQuantity, max: maxQuantity });
  }

  return (
    <div className="cmp-quantity-selector__wrapper">
      <div
        className="util-visually-hidden"
        id={`quantity-selector-${sku}`}
        data-testid={`quantity-selector-${sku}`}
      >
        {label}
      </div>
      <div
        className="cmp-quantity-selector"
        aria-labelledby={`quantity-selector-${sku}`}
      >
        <button
          type="button"
          className="cmp-quantity-selector__button"
          aria-label="Decrease Quantity"
          aria-disabled={qty <= minQuantity}
          disabled={qty <= minQuantity}
          onClick={() => updateQuantities({
            isFrontTire,
            isSplitFitment,
            minQuantity,
            maxQuantity,
            newQuantity: Number.parseInt(qty, 10) - 1,
          })}
          data-testid={`decrease-button-${sku}`}
        >
          <span>-</span>
        </button>
        <input
          id={`quantity-selector-input-${sku}`}
          type="number"
          className="cmp-quantity-selector__input"
          min={minQuantity}
          max={maxQuantity}
          value={qty}
          onBlur={() => {
            if (qty === '') {
              updateQuantities({
                isFrontTire,
                isSplitFitment,
                minQuantity,
                maxQuantity,
                newQuantity: minQuantity,
              });
            }
          }}
          onChange={(e) => updateQuantities({
            isFrontTire,
            isSplitFitment,
            minQuantity,
            maxQuantity,
            newQuantity: e.target.value,
          })}
          aria-label={`Quantity of ${quantity} selected`}
          data-testid={`quantity-input-${sku}`}
        />
        <button
          type="button"
          className="cmp-quantity-selector__button"
          aria-label="Increase Quantity"
          aria-disabled={qty >= maxQuantity}
          disabled={qty >= maxQuantity}
          onClick={() => updateQuantities({
            isFrontTire,
            isSplitFitment,
            minQuantity,
            maxQuantity,
            newQuantity: Number.parseInt(qty, 10) + 1,
          })}
          data-testid={`increase-button-${sku}`}
        >
          <span>+</span>
        </button>
      </div>
    </div>
  );
};

QuantitySelector.propTypes = {
  sku: propTypes.string.isRequired,
  isSplitFitment: propTypes.bool.isRequired,
  isFrontTire: propTypes.bool.isRequired,
};

export { QuantitySelector };
